import React from 'react';
import '../App.css';
import './services1.css';
import './seo.css';
import SEO from '../SEO';
import PopUp_Divs from './popup_divs.js'
import Purple_smoke from '../images/purple_smoke_vid.mp4'; 
import { BsGlobeAmericas } from "react-icons/bs";
import { FaChartLine } from "react-icons/fa";
import { Ri24HoursLine } from "react-icons/ri";
import Analysis from '../images/analysis2.gif';
import Book from '../images/open-book2.gif';
import BarChart from '../images/bar-chart2.gif';
import Seo from '../images/seo2.gif';
import Website from '../images/webpage-list2.gif';
import Boss from '../images/boss2.gif';
import { useScrollBehavior } from './useScrollBehavior.js'; 
import Footer from './footer.js' 


const SEO_page = () => {

    useScrollBehavior();

    const title = "SEO Services | Yokai Software";
const description = "Yokai Software provides SEO services focused on stronger visibility, better rankings, and qualified traffic growth.";
const canonical = "https://yokaisoftware.com/seo";
const image = "https://yokaisoftware.com/yokai_apple_touch_icon2.png";

const schema = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebPage",
      "@id": "https://yokaisoftware.com/seo#webpage",
      url: "https://yokaisoftware.com/seo",
      name: "SEO Services | Yokai Software",
      description:
        "Yokai Software provides SEO services focused on stronger visibility, better rankings, and qualified traffic growth.",
    }
  ]
};

    const ROUTES = {
      "Learn More": "/about",
      "Contact Us": "/ContactPage",
      "See Plans": "/about",
      "Get Support": "/ContactPage",
      "View Case Studies": "/portfolio",
      "Get a Free Quote": "/ContactPage",
    };
    
    React.useEffect(() => {
      const handler = (e) => {
        
        const el = e.target.closest('button, a, [role="button"], .btn, .btn_seo, .button, .my-button-class, [data-button]');
        if (!el) return;
    
        //const label = (el.textContent || "").trim();
        //const path = ROUTES[label];

        const label = (el.textContent || "").replace(/\s+/g, ' ').trim();
        const path =
        ROUTES[label] ||
        el.getAttribute('data-route') ||
        el.getAttribute('href'); 


        if (!path) return;           
         sessionStorage.removeItem('scrollPosition');
       
        window.scrollTo(0, 0);
    
        e.preventDefault();          
        window.location.assign(path); 
      };
      
      document.addEventListener('click', handler, true);
      return () => document.removeEventListener('click', handler, true);
    }, []);
    
    
    return (
        <div id='services_div1'>
            <SEO
                title={title}
                description={description}
                canonical={canonical}
                image={image}
                schema={schema}
            />
            <div className='module_service' id='service_moduleOne'>
                <video  autoPlay muted loop playsInline preload="auto" crossorigin="anonymous" fetchpriority="high">
                    <source src={Purple_smoke} type="video/mp4" fetchpriority="high"/>
                        Your browser does not support the video tag.
                </video>
                <div id='services_heading1'><h1>Search Engine Optimization</h1></div>
            </div>
            <div className='module_service' id='service_moduleTwo'>
                <div id='service_mod2_container'>
                    <div id='service_mod2_inner1'>
                        <h1 id='service_about_h1'>Unlock Growth With SEO That Actually Works</h1>
                        <h2>Stand Out. Be Seen. Win Customers.</h2>
                    </div>
                    <div id='service_mod2_inner2'>
                        <p>SEO (Search Engine Optimization) is how your business gets found online.
                            When someone searches for the services you offer, they almost always 
                            start with Google. If your business isn't showing up on the first page, 
                            your competitors are the ones getting those calls and sales.
                            Good SEO puts your website in front of the right people at the right 
                            time. It's not just about ranking higher — it's about getting real 
                            customers who are already searching for what you do.</p>
                            <br></br>
                            <h3>With SEO done right, your business:</h3>
                            <ul>
                                <li>Shows up ahead of the competition</li>
                                <li>Builds trust with potential customers</li>
                                <li>Turns searches into phone calls, appointments, and sales</li>
                            </ul>
                            <h3>If your website is buried, it's invisible. SEO is what makes it work for you.</h3>
                    </div>
                </div>

            </div>
             <div className='module_service' id='service_moduleTwo'>
                <PopUp_Divs
                pageKey="services1"
                data={[
                    { 
                        buttons: ["Learn More", "Contact Us"], 
                        h2: "Why SEO is Important", 
                        p: "Nearly 90% of people never click past the first page of Google. If your site isn't there, you're invisible. SEO helps your business stand out, attract real customers, and turn searches into phone calls, appointments, and sales. It's one of the most cost-effective ways to grow your business online." 
                    },
                    { 
                        buttons: ["See Plans", "Get Support"],
                        h2: "How SEO Helps Your Business", 
                        p: "With the right SEO strategy, your website can rise above competitors, build trust with customers who are actively searching for your services, and attract traffic that actually converts into revenue. SEO is more than rankings — it's about putting your business in front of the people who are already looking for exactly what you offer." 
                    },
                    { 
                        buttons: ["View Case Studies"],
                        h2: "The Power of SEO", 
                        p: "SEO isn't just about ranking higher on Google — it's about getting the right people to your website at the exact moment they're looking for your services. Unlike ads, SEO keeps working long after the campaign ends, building steady traffic and trust for your business." 
                    }
                  ]}
                />
             </div>
             <div className='module_service' id='service_moduleThree'>
                <div id='seo_mod2_container2'>
                    <div className="conversion-module_seo">
                        <div id='conversion-module_subdiv_seo'>
                            <h1>The Value of SEO for Your Business</h1>

                        <p>
                            Search Engine Optimization isn't a luxury anymore — it's a necessity. 
                            Every day, thousands of people search online for products and services 
                            in your industry. If your business doesn't appear where they're looking, 
                            you're losing customers to competitors who do.
                            <br></br>
                            SEO makes your website work harder for you. It builds visibility, trust, 
                            and consistent traffic without having to rely only on paid ads. Done 
                            right, SEO is one of the most powerful long-term investments you can make 
                            in your business growth.
                        </p>
                        </div>

                <div className="conversion-funnel_seo">
                    <h2>What SEO Can Do For You</h2>
                    <div className="step"><BsGlobeAmericas className="icon_seo"/><strong>Visibility</strong> Appear on the first page where customers are searching.</div>
                    <div className="step"><FaChartLine className="icon_seo"/><strong>Cost-Effective Growth</strong> Unlike paid ads, SEO compounds over time and keeps delivering value.</div>
                    <div className="step"><Ri24HoursLine className="icon_seo"/><strong>24/7 Marketing</strong> Your optimized website works around the clock, even when you're off the clock.</div>
                </div>

                <ul className="conversion-points_seo">
                    <h2>How Yokai Approaches SEO</h2>
                    <h3>At Yokai, we focus on strategies that are proven to work and tailored to your business:</h3>
                        <li>Local SEO that makes you the first choice in your city</li>
                        <li>Technical improvements to speed, mobile-friendliness, and site health</li>
                        <li>Content strategies that position your business as the authority</li>
                        <li>Continuous monitoring to adapt to Google's ever-changing algorithms</li>
                </ul>

                <div className="conversion-ctas_seo">
                    <div href="/ContactPage" id='btn-primary_seo' className="btn_seo">Get a Free Quote</div>
                    <div href="/portfolio" id='btn_service_seo' className="btn_seo">View Case Studies</div>
                </div>
                </div>
                </div>
             </div>
            <div className='module_service' id='service_moduleFour'>
                <div id='mod4_div2_service'>
                    <div id='mod4_div2_service_heading'>
                        <h1>Why Choosing Yokai Software
                        Is The Right Choice for Your SEO Growth</h1>
                    </div>
                    <div id='mod4_sub_div_container_service'>
                        <div className='mod4_sub_div_service'>		
                                <div id='mod4_Sub_div_icon1_service'>
                                    <img src={Analysis } alt="Analysis  icon" className="analysis " />
                                </div>
                                <h2>Detailed Analysis</h2>
                                <p>We dig deep into your industry, research 
                                    your competitors, and study how customers 
                                    are searching online shaping a 
                                    custom strategy design.</p>
                        </div>
                        <div className='mod4_sub_div_service'>
                                <div id='mod4_Sub_div_icon2_service'>
                                    <img src={Book} alt="Book icon" className="book" />
                                </div>		
                                <h2>Transparent Approach</h2>
                                <p>We don't hide behind jargon or “secret formulas.” You'll always know what 
                                    we're doing, why we're doing it, and how it's helping your business grow. 
                                    </p>
                        </div>
                        <div className='mod4_sub_div_service'>
                            <div id='mod4_Sub_div_icon3_service'>
                                <img src={BarChart} alt="BarChart icon" className="barchart" />
                            </div>
                            <h2>Results-Driven</h2>
                            <p>SEO isn't about promises — it's about proof. Our strategies focus on 
                                generating real visibility, real traffic, and real customers.</p>
                        </div>
                    </div>

                </div>				
            </div>
            <Footer/>
            
        </div>
    );
};

export default SEO_page;